
import { gsap } from "gsap";

import "./../scss/about.scss"

import { ScrollTrigger } from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger)

const $logo = document.querySelector('.logo')
const $hambuger = document.querySelector('.hambuger')
const $menuPage = document.querySelector('.mob_menu')
//const buttons = document.querySelectorAll(".mob_button");

let isOpen = false;
let isRed = false;

gsap.set(".menu_path", {visibility:"visible"});

$hambuger.addEventListener("click", hambugerClick);

function hambugerClick() {
	if (isOpen && !isRed) {
		isOpen = false
		gsap.to($menuPage, {
			left: "100vw",
			duration: 0.3
		});
		$logo.style.filter = "brightness(1)";
		$hambuger.style.filter = "brightness(1)";
		console.log('The variable is ' + isOpen);
	  }else if(isOpen && isRed){
		isOpen = false
		gsap.to($menuPage, {
			left: "100vw",
			duration: 0.3
		});
		$logo.style.filter = "brightness(10)";
		$hambuger.style.filter = "brightness(10)";
	  } else {
		isOpen = true
		gsap.to($menuPage, {
			left: 0,
			duration: 0.3
		});
		$logo.style.filter = "brightness(10)";
		$hambuger.style.filter = "brightness(10)";
	  }
}

gsap.to(".mouse_wheel", {
	keyframes: [
		{height:8,y:10, ease: "sine.in",duration:.7,delay:.8},
		{height:18,y:15,duration:.2},
		{height:8,y:24,duration:.2},
		{height:8,y:10, ease: "sine.out",duration:.2, delay:3}
	],
	repeat: -1,
	transformOrigin: "center bottom"
})

/*--------------------
Contants
--------------------*/
const speedWheel = 0.008
const speedDrag = -0.1

/*--------------------
Get Z
--------------------*/
const getZindex = (array, index) => (array.map((_, i) => (index === i) ? array.length : array.length - Math.abs(index - i)))

/*--------------------
Items
--------------------*/
//let active = 0
const $items = document.querySelectorAll('.about_slide')
const $names = document.querySelectorAll('.name-item')
const carouselW = document.getElementsByClassName("carousel_flex")

/*--------------------
MATCH MEDIA
--------------------*/
let mm = gsap.matchMedia(),
    breakPoint = 800;

mm.add({

  isDesktop: `(min-width: ${breakPoint}px)`,
  isMobile: `(max-width: ${breakPoint - 1}px)`,
  reduceMotion: "(prefers-reduced-motion: reduce)"

}, (context) => {
  /*--------------------
  Vars
  --------------------*/
  let executed = false
  let okDelta = true
  let startX = 0
  let startY = 0
  let active = 0
  let isDown = false
  let maxLength = $items.length
  let { isDesktop, isMobile, reduceMotion } = context.conditions;

  /*--------------------
    CIRCLES
  ----------------------*/
  const $circles = document.querySelectorAll('.circle')

  const displayCircles = (circle, index) => {
    circle.style.setProperty('--itemnum', index)
    circle.style.setProperty('--trans', 10 + "px")
  }
  $circles.forEach((circle, index) => displayCircles(circle, index))

  const circleAdd = (num) => {
    $circles.forEach((circle, index) => modifyCloud(circle, index, num))
  }
  const circleReset = () => {
    $circles.forEach((circle, index) => resetCloud(circle, index))
  }

  const resetCloud = (circle, index) => {
    let groupnum = Math.floor(index/4) + 1
    circle.style.setProperty('--group', groupnum)
    
    circle.classList.remove("case01");
    circle.classList.remove("case02");
    circle.classList.remove("case03");
    circle.classList.add("case00");
    let addValue = 0
    circle.style.setProperty('--trans', addValue + "px")
  }
  const modifyCloud = (circle, index, num) => {
    //let circlePath = circle.querySelector('path')
    let groupnum = Math.floor(index/4) + 1
    circle.style.setProperty('--group', groupnum)
    switch(active) {
      case 0:
        circle.classList.remove("case01");
        circle.classList.add("case00");
        let addValue = 0
        circle.style.setProperty('--trans', addValue + "px")
      break;
      case 1:
        circle.classList.remove("case00");
        circle.classList.remove("case02");
        circle.classList.add("case01");
        break;
      case 2:
        circle.classList.remove("case01");
        circle.classList.remove("case03");
        circle.classList.add("case02");
        break;
      case 3:
          circle.classList.remove("case02");
          circle.classList.add("case03");
          break;
      default:
    }
  }

  function animateIt(num) {
    active += num
    let yValue = active * 100 * -1
    let activeSlide = active
    //let activeSlide = $inner[active-1]
    console.log("executed : " + executed +" active : " + active + " activeSlide : " + activeSlide)
    circleAdd(num);
    if(active == 0){
      isRed = false
      gsap.to(".about_bg",{
        backgroundColor: "white",
      })
      gsap.to(".white_dot",{
        backgroundColor: "white",
      })
      gsap.to(".header_item",{
        filter: "brightness(1)",
      })
    }else if(active >= 1){
      isRed = true
      gsap.to(".about_bg",{
        backgroundColor: "#ee2040",
      })
      gsap.to(".white_dot",{
        backgroundColor: "#ee2040",
      })
      gsap.to(".header_item",{
        filter: "brightness(10)",
      })
    }; 

    if(executed == true){
      //executed = true
      gsap.to(".about_wrapper", {
          duration: .4,
          y: yValue + "vh",
          onComplete:AnimateEnd(),
        }
      );
    }
  }
  function AnimateEnd() {
    setTimeout(function(){
      okDelta = true
      executed = false
      console.log("okDelta : " + okDelta + " executed : " + executed)
    }, 800);
  }
  
  if(isDesktop){
  
    function scrollWrapper(event) {
      //event.preventDefault();
      if(okDelta==true){
        yy = Math.min(Math.max(-100, event.deltaY * 10), 100) ;
        //console.log("okDelta " + yy + " maxLength" + maxLength)
        if (!executed) {
          if(yy >= 100 && active < maxLength - 1){
            executed = true
            animateIt(1)
          }else if(yy <= -100 && active >= 1){
            executed = true
            animateIt(-1)
          }
        }
      }else{
        console.log("Nothing")
      } 
    }
    let yy = 0;
    const el = document.querySelector(".about_wrapper");
    el.onwheel = scrollWrapper;

    /*--------------------
    Reset about
    --------------------*///

    const resetPage = (e) => {
      console.log("RESET // okDelta : " + okDelta + " executed : " + executed + " active : " + active)

      if(executed == false){
        active = 0
        executed = true
        gsap.to(".about_wrapper", {
            duration: .4,
            y: 0 + "vh",
            onComplete:AnimateEnd(),
          }
        )
        gsap.to(".about_bg",{
          backgroundColor: "white",
        })
        gsap.to(".white_dot",{
          backgroundColor: "white",
        })
        gsap.to(".header_item",{
          filter: "brightness(1)",
        })
        circleReset()
        //circleAdd(0);
      }
    }
    window.addEventListener("resize", resetPage);

    /*=================================================

      Key

    ==================================================== */

    /* const input = document.querySelector("input");
    const log = document.getElementById("log"); */

    document.addEventListener("keydown", logKey);

    function logKey(eKey) {
      //log.textContent += ` ${e.code}`;
      console.log(eKey.key)
      if(eKey.key == "ArrowDown" && active < maxLength - 1){
        if (!executed) {
          executed = true
          animateIt(1)
        }
      }else if(eKey.key == "ArrowUp" && active >= 1){
        if (!executed) {
          executed = true
          animateIt(-1)
        }
      }
    }
    
  }else if(isMobile){
    console.log("It's MOBILE")

    const boxes = gsap.utils.toArray('.slider_slide');
    boxes.forEach(box => {
      gsap.fromTo(box, {scale: 0.7},{ 
        scale: 1,
        scrollTrigger: {
          trigger: box,
          start:"top bottom",
          end:"top center",
          scrub: true
        }
      })
    });
    const titles = gsap.utils.toArray('.oktitle');
    titles.forEach(oktitle => {
      gsap.fromTo(oktitle, {yPercent: 0},{ 
        yPercent: 110,
        scrollTrigger: {
          trigger: ".slider_wrapper",
          start:"top 80%",
          end:"top 30%",
          scrub: true
        }
      })
    });

    function count_D(mouseProgress) {
      if (mouseProgress > 50 && active < maxLength - 1){
        mouseProgress = 0
        if (!executed) {
          executed = true;
          animateIt(1)
        }
      } else if (mouseProgress < -50 && active >= 1){
        mouseProgress = 0
        if (!executed) {
          executed = true;
          animateIt(-1)
        }
      }
    }

    /*--------------------
    Click on Items
    --------------------*/
    
    const handleMouseMove = (e) => {
      if (!isDown) return
      const y = e.clientY || (e.touches && e.touches[0].clientY) || 0
      const mouseProgress = (y - startY) * speedDrag *100
      //progress = progress + mouseProgress
      startY = y
      count_D(mouseProgress)
    }
    const handleMouseDown = e => {
      isDown = true
      startY = e.clientY || (e.touches && e.touches[0].clientY) || 0
    }
    const handleMouseUp = () => {
      isDown = false
    }

    //document.addEventListener('wheel', handleWheel)
    document.addEventListener('mousedown', handleMouseDown)
    document.addEventListener('mousemove', handleMouseMove)
    document.addEventListener('mouseup', handleMouseUp)
    document.addEventListener('touchstart', handleMouseDown)
    document.addEventListener('touchmove', handleMouseMove)
    document.addEventListener('touchend', handleMouseUp) 

  }
  return () => { 
    console.log("NONE")
  }
});

